import React, { useEffect, useRef, useState } from 'react';
import './report.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import {
  getJsonFromStorage,
  getPaginationOpts, getResponseError,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import {
  deleteReportTemplate,
  editReportTemplateById,
  loadReportTemplateById,
  loadReportTemplateList,
} from '../actions';
import { getSystemData } from '../../System/reducer';
import Loader from '../../../components/base/Loader/Loader';
import { getReportData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { statusFormatter, dateTimeFormatter, userPositionFormatter } from '../../../utils/formatters';
import { REPORT_TEMPLATE_STATUS, REPORT_TEMPLATE_STATUS_NAMES } from '../../../configs';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import ReportTemplateForm from './ReportTemplateForm';
import { showGlobalConfirm } from '../../System/actions';
import { getUserData } from '../../User/reducer';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import { REPORT_MODULE } from '../../../configs/moduleNames';

export default function ReportTemplatePage() {
  const blockRef = useRef(null);
  const dispatch = useDispatch();
  const store = useStore();
  const { updatePeriod } = useSelector(getSystemData);
  const {
    reportTemplateListMeta,
    loadingReportTemplateList,
    reportTemplateList,
    loadingCurrentReportTemplate,
    currentReportTemplate,
    loadingEditReportTemplate,
    loadingDeleteReportTemplate,
    loadingCreateReportTemplate,
  } = useSelector(getReportData);
  const { loadingUserList } = useSelector(getUserData);
  const [isShowForm, setIsShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { formatMessage } = useIntl();
  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[REPORT_MODULE].reportTemplateListMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: getValues(),
    };
    const p1 = dispatch(loadReportTemplateList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  const defaultDate = getDefaultDataRange();
  const defaultFilterValues = {
    created_at_from: defaultDate[0], created_at_to: defaultDate[1], search: '', created_at: '',
  };
  const { getValues } = useForm({ defaultValues: getJsonFromStorage('report-template-filter', defaultFilterValues) });

  const handleActive = item => event => {
    if (!item) {
      return;
    }

    // item.status === REPORT_TEMPLATE_STATUS.ACTIVE

    dispatch(editReportTemplateById({ id: item.id, values: { ...item, status: item.status === REPORT_TEMPLATE_STATUS.ACTIVE ? REPORT_TEMPLATE_STATUS.ARCHIVE : REPORT_TEMPLATE_STATUS.ACTIVE } }))
      .then(() => {
        loadData();
        successNotification('Изменение шаблона', 'Изменение прошло успешно');
      })
      .catch(response => errorNotification('Изменение шаблона', getResponseError(response)));

    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  const handleDelete = item => event => {
    dispatch(showGlobalConfirm({
      confirmMessage: `Удаление шаблона "${item.name || ''}"`,
      confirmButtonText: 'Удалить',
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(deleteReportTemplate(item.id)).then(() => {
        loadData();
        successNotification('Удаление шаблона', 'Удаление прошло успешно');
      }).catch(response => {
        errorNotification('Удаление шаблона', getResponseError(response));
      });
    }).catch(() => {});

    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  const handleClose = () => {
    setIsShowForm(false);
    setIsEdit(false);
  };

  const columns = [
    {
      dataField: 'name',
      text: 'Наименование отчета',
      disableSort: true,
    },
    {
      dataField: 'created_at',
      text: 'Дата создания',
      formatter: dateTimeFormatter,
      disableSort: true,
    },
    {
      dataField: 'creator',
      text: 'Автор',
      headerClassName: 'user-column',
      formatter: userPositionFormatter,
      disableSort: true,
    },
    {
      dataField: 'status',
      text: 'Статус',
      disableSort: true,
      formatter: a => statusFormatter(a, 'report.template.status', REPORT_TEMPLATE_STATUS_NAMES),
    },
  ];

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={(
        <div className="more-wrapper">
          <Button variant="link" className="w-100 more-button" onClick={handleActive(item)}>
            {item.status === REPORT_TEMPLATE_STATUS.ACTIVE ? 'Архивировать' : 'Активировать'}
          </Button>
          <Button variant="link" className="w-100 more-button" onClick={handleDelete(item)}>
            Удалить
          </Button>
        </div>
      )}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  return (
    <div className="page application-page">
      <Loader global loading={loadingReportTemplateList || loadingCurrentReportTemplate || loadingEditReportTemplate || loadingDeleteReportTemplate || loadingCreateReportTemplate || loadingUserList} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.report.template' })}</div>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid
                data={reportTemplateList}
                columns={columns}
                name="report-template-list"
                settingsFormatter={moreFormatter}
              />
            </div>
          </div>
          <Pagination meta={reportTemplateListMeta} list={reportTemplateList} handleChangeMeta={loadData} />
        </div>
      </div>
      {isShowForm ? <ReportTemplateForm key={currentReportTemplate && currentReportTemplate.id} isEdit={isEdit} current={currentReportTemplate} loadData={loadData} close={handleClose} /> : null}
    </div>
  );
}
